import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

import { useI18n } from '@/providers/i18n';

import { detailsSchema, type DetailsValues } from '../schemas';
import styles from './CheckoutDetails.module.css';
import StepHeader from './StepHeader';

interface CheckoutDetailsProps {
  defaultValues?: Partial<DetailsValues>;
  onBack: () => void;
  onSubmit: (values: DetailsValues) => void;
}

export default function CheckoutDetails({
  defaultValues,
  onBack,
  onSubmit,
}: CheckoutDetailsProps) {
  const { t } = useI18n();
  const form = useForm<DetailsValues>({
    resolver: zodResolver(detailsSchema),
    defaultValues: {
      name: defaultValues?.name ?? '',
      email: defaultValues?.email ?? '',
      phone: defaultValues?.phone ?? '',
    },
  });

  const { errors } = form.formState;

  return (
    <form onSubmit={form.handleSubmit(onSubmit)}>
      <StepHeader step={2} label="DETAILS" />
      <div className={styles.form}>
        <div className="field">
          <label htmlFor="co-name">{t('label.name')}</label>
          <input id="co-name" placeholder="FIRST LAST" {...form.register('name')} />
          {errors.name && <span className="err">{errors.name.message}</span>}
        </div>
        <div className={styles.row2}>
          <div className="field">
            <label htmlFor="co-email">{t('label.email')}</label>
            <input
              id="co-email"
              type="email"
              placeholder="YOU@DOMAIN.COM"
              {...form.register('email')}
            />
            {errors.email && <span className="err">{errors.email.message}</span>}
          </div>
          <div className="field">
            <label htmlFor="co-phone">{t('label.phone')}</label>
            <input id="co-phone" placeholder="+374 ..." {...form.register('phone')} />
          </div>
        </div>
      </div>
      <div className={styles.actions}>
        <button type="button" className="btn btn-ghost" onClick={onBack}>
          {t('cta.back')}
        </button>
        <button type="submit" className="btn btn-fill btn-arrow">
          {t('cta.continue')}
        </button>
      </div>
    </form>
  );
}
